/// <reference path="../global.d.ts" />
/*!
 * @preserve
 * intl.js
 * Poliyfill: missing intl.tolocalized* Function for Date/Time on IE10
 *
 * @version 1.0
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license MIT
 */

export module intl {
    let formattedDate:  { [key: string]: string },
        formattedTime:  { [key: string]: string };

    /**
     * Einfache "pad"-Funktion um eine Zahl mit führenden Nullen aufzufüllen
     * @param num
     * @param padlen
     * @param padchar
     */
    let paddy = function(num:number|string, padlen:number, padchar:string):string {
        let pad_char = typeof padchar !== 'undefined' ? padchar : '0';
        let pad = new Array(1 + padlen).join(pad_char);
        return (pad + num).slice(-pad.length);
    };

    // noinspection JSUnusedLocalSymbols
    /**
     * Formatiere das Datum entsprechend Ländercode
     * @param locales
     * @param options
     */
    let dateFormatOverride = function(locales?: string, options?: object): string {
        let formatGB = (this.getMonth()+1) + "/"
            + this.getDate() + "/"
            + this.getFullYear();
        let formatDE = paddy(this.getDate(), 2, "0") + "."
            + paddy(this.getMonth() + 1, 2, "0") + "."
            + this.getFullYear();

        formattedDate = {
            "en-US": formatGB,
            "de-DE": formatDE,
        };

        return formattedDate[locales] || formattedDate['de-DE'];
    };

    /**
     * Formatiere Uhrzeit entsprechend Ländercode
     * @param locales
     */
    let timeFormatOverride = function(locales?: string): string {
        let ampm = "am";
        let hr = this.getHours();
        if( hr > 12 ) {
            hr -= 12;
            ampm = "pm";
        }

        let formatGB = hr + ":"
            + paddy(this.getMinutes(), 2, "0") + ":"
            + paddy(this.getSeconds(), 2, "0") + " "
            + ampm;

        let formatDE = paddy(this.getHours(), 2, "0") + ":"
            + paddy(this.getMinutes(), 2, "0") + ":"
            + paddy(this.getSeconds(), 2, "0");

        formattedTime = {
            "en-US": formatGB,
            "de-DE": formatDE,
        };

        return formattedTime[locales] || formattedTime['de-DE'];
    };

    /**
     * Prüfe ob i12n-Funktionen nativ zur Verfügung stehen (fehlen <= IE 10)
     */
    function toLocaleDateStringSupportsLocales() {
        try {
            new Date().toLocaleDateString("i");
        } catch (e) {
            return e.name === "RangeError";
        }
        return false;
    }

    /**
     * Polyfill bei Bedarf nachladen
     */
    if(!toLocaleDateStringSupportsLocales()){
        console.warn("IE10 Support for dein-ip-check.de is deprecated");
        Date.prototype.toLocaleDateString = dateFormatOverride;
        Date.prototype.toLocaleTimeString = timeFormatOverride;
    }

    window.dateFormatOverride = dateFormatOverride;
    window.timeFormatOverride = timeFormatOverride;
}
